import React, { useContext } from 'react'
import cross from '../assets/cross1.png'
import { LockKeyholeOpen } from 'lucide-react'
import { CantiqueContextAPI } from '../Context/CantiqueContext'

const Home = () => {
    const { setSidebarOpen } = useContext(CantiqueContextAPI);

    return (
        <div className="home">
            <div className="home__container">
                <div className="home__card">
                    <div className="home__card__image">
                        <img src={cross} alt="Cross ALCM" className="home__card__img" />
                    </div>
                    <h2 className="home__card__title">Psaume 150</h2>
                    <p className="home__card__description">
                        Louez l'Éternel! Louez Dieu dans son sanctuaire, louez-le dans l'étendue, où éclate sa puissance!
                        Louez-le pour ses hauts faits, louez-le selon l'immensité de sa grandeur!
                        Louez-le au son de la trompette, louez-le avec le luth et la harpe!
                        Louez-le avec le tambourin et les danses, louez-le avec les instruments à cordes et le chalumeau!
                        Louez-le avec les cymbales retentissantes, louez-le avec les cymbales éclatantes!
                        Que tout ce qui respire loue l'Éternel! 
                       <span> Louez l'Éternel!</span>
                    </p>
                </div>
                <div
                  className="home__see__cantique"
                  onClick={() => setSidebarOpen(true)}
                  aria-label="Voir les cantiques"
                >
                    <span><LockKeyholeOpen size={13} /></span>
                    <span>Voir les cantiques</span>
                </div>
            </div>
        </div>
    )
}

export default Home